import { defineStore } from 'pinia'
import axios from '../axios'

// API_BASE_URL removed - using axios baseURL from environment variables

export const useLeagueTeamsStore = defineStore('leagueTeams', {
  state: () => ({
    teams: [],  // Object to store teams by league ID
    searchTerm: '',
    loading: false,
    error: null,
    expandedLeagueId: null,
    searchResultTeams: []
  }),

  getters: {
    getTeamsByLeague: (state) => (leagueId) => {
      return state.teams[leagueId] || []
    },
    getTeamsCount: (state) => (leagueId) => {
      return state.teams[leagueId]?.length || 0
    }
  },

  actions: {
    async fetchTeamsByLeague(leagueId) {
      const response = await axios.get(`/api/teams/get-league-teams/${leagueId}`)
      this.teams[leagueId] = response.data
    },

    async addTeamToLeague(data) {
      try {
        const response = await axios.post(`/api/teams/add-team-to-league`, {
          teamId: data.team.id,
          leagueId: data.leagueId
        })
        
        // Instead of fetching all teams again, just add the new team to the list
        if (this.expandedLeagueId) {
          const currentTeams = this.teams[this.expandedLeagueId] || []
          this.teams[this.expandedLeagueId] = [...currentTeams, data.team]
        }
        
        return response.data
      } catch (err) {
        console.error('Error adding team to league:', err)
        throw err
      }
    },

    async fetchTeams(leagueId) {
      try {
        const response = await axios.get(`/api/leagues/${leagueId}/teams`)
        this.teams = response.data
        return response.data
      } catch (error) {
        console.error('Error fetching teams:', error)
        throw error
      }
    },

    async searchTeams(query) {
      try {
        this.loading = true
        this.error = null
        const response = await axios.get(`/api/teams/search-teams/${query}`)
        return response.data
      } catch (err) {
        this.error = err.message
        console.error('Error searching teams:', err)
        return []
      } finally {
        this.loading = false
      }
    },

    clearTeams(leagueId) {
      if (leagueId) {
        delete this.teams[leagueId]
      } else {
        this.teams = {}
      }
    },

    setExpandedLeague(leagueId) {
      this.expandedLeagueId = leagueId
    },

    removeTeamFromLeague(leagueId, rowId) {
      // Remove team from local store by filtering out the team with matching row id
      if (this.teams[leagueId]) {
        this.teams[leagueId] = this.teams[leagueId].filter(team => team.id !== rowId)
      }
    }
  }
}) 